import React, {Component} from 'react';
import {
  Row,
  Card,
  CardBody,
  Col,
  Input, Button,
} from 'reactstrap';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../components/common/CustomBootstrap';
import {connect} from 'react-redux';
import {reactTableText} from '../constants/configs';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {fixedToWithoutRound, getDatePickerProps, getTokenDecimals} from '../helpers/Utils';
import i18n from '../services/i18n';
import JalaliUtils from '@date-io/jalaali';
import MomentUtils from '@date-io/moment';
import Api from '../services/Api';
import {isEmpty} from 'lodash';
import moment from 'moment';
import Breadcrumb from "./navs/Breadcrumb";
import fa_IR from "../constants/locales";

class RangeUserFeeReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
      selectedTag: 'last1h',
      since: moment().subtract(1, 'hours'),
      to: moment(),
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    const {since, to} = this.state;
    this.setState({loading: true});
    try {
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/range-statistics',
        null,
        {
          params: {
            ...(since ? {since: moment.utc(since).format('YYMMDDHHmm')} : null),
            ...(to ? {to: moment.utc(to).format('YYMMDDHHmm')} : null),
          },
          cancelToken: null,
        }
      );
      this.setState({data});
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    }, this.fetchData);
  };

  onClickLast1h = () => {
    this.setState({
      selectedTag: 'last1h',
      since: moment().subtract(1, 'hours'),
      to: moment(),
    }, this.fetchData);
  };

  onClickLast24h = () => {
    this.setState({
      selectedTag: 'last24h',
      since: moment().subtract(24, 'hours'),
      to: moment(),
    }, this.fetchData);
  };

  onClickLast7d = () => {
    this.setState({
      selectedTag: 'last7d',
      since: moment().subtract(7, 'days'),
      to: moment(),
    }, this.fetchData);
  };

  onClickLast30d = () => {
    this.setState({
      selectedTag: 'last30d',
      since: moment().subtract(30, 'days'),
      to: moment(),
    }, this.fetchData);
  };

  getColumns = t => {
    const {since, to} = this.state.data;
    return [
      {
        accessor: 'logoUrl',
        Cell: props => <img src={props.value} className="avatar-mini" alt={props.original.name}/>,
        width: 60,
      },
      {
        Header: t('Name'),
        accessor: 'localeName',
      },
      {
        Header: t('Total Users Fee In Start Date'),
        accessor: 'symbol',
        Cell: props => <span>{
          !isEmpty(since) && !isEmpty(since.fee)?
            fixedToWithoutRound(
              since.fee[props.value],
              getTokenDecimals(props.value)
            ) :
            null
        }</span>
      },
      {
        Header: t('Total Users Fee In End Date'),
        accessor: 'symbol',
        Cell: props => <span>{
          !isEmpty(to) && !isEmpty(to.fee)?
            fixedToWithoutRound(
              to.fee[props.value],
              getTokenDecimals(props.value)
            ) :
            null
        }</span>
      },
      {
        Header: t('Differences In Total Users Fee'),
        accessor: 'symbol',
        Cell: props => <span>{
          !isEmpty(to) && !isEmpty(to.fee) && !isEmpty(since.fee)?
            fixedToWithoutRound(
              to.fee[props.value] - since.fee[props.value],
              getTokenDecimals(props.value)
            ) :
            null
        }</span>
      },
    ];
  };

  render() {
    const {t, tokens} = this.props;
    const {since, to, loading, selectedTag} = this.state;
    const newTokens = [...tokens];
    return (
      <ThemeProvider
        theme={createMuiTheme({
          typography: {
            fontFamily: 'IRANSans',
          }})
        }
      >
        <MuiPickersUtilsProvider
          utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
          locale={i18n.language}
        >
          <Row>
            <Colxx xxs="12">
              <Breadcrumb match={this.props.match}/>
              <Separator className="mb-5"/>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" className="mb-4">
              <Card className="h-100">
                <CardBody>
                  <Row className="mb-5">
                    <Col className='col-6 col-lg-3'>
                      <span>{t('start date')}</span>
                      <DateTimePicker
                        {...getDatePickerProps()}
                        value={since}
                        disableMinutes={true}
                        TextFieldComponent={props => <Input className="datePickerInput" {...props} />}
                        onChange={date => {
                          this.handleDateChange('since', date);
                        }}
                      />
                    </Col>
                    <Col className='col-6 col-lg-3'>
                      <span>{t('end date')}</span>
                      <DateTimePicker
                        {...getDatePickerProps()}
                        value={to}
                        TextFieldComponent={props => <Input className="datePickerInput" {...props} />}
                        onChange={date => {
                          this.handleDateChange('to', date);
                        }}
                      />
                    </Col>
                    <Col className='col-12 col-lg-6 mt-lg-0 d-flex flex-row align-items-end flex-wrap'>
                      <Button className='mr-3 mt-2' outline={selectedTag !== 'last1h'} onClick={this.onClickLast1h}>{t('last 1 hour')}</Button>
                      <Button className='mr-3 mt-2' outline={selectedTag !== 'last24h'} onClick={this.onClickLast24h}>{t('last 24 hours')}</Button>
                      <Button className='mr-3 mt-2' outline={selectedTag !== 'last7d'} onClick={this.onClickLast7d}>{t('last 7 days')}</Button>
                      <Button className='mt-2' outline={selectedTag !== 'last30d'} onClick={this.onClickLast30d}>{t('last 30 days')}</Button>
                    </Col>
                  </Row>
                  <ReactTable
                    manual
                    className="-highlight"
                    data={newTokens}
                    loading={loading}
                    sortable={false}
                    resizable={true}
                    showPagination={false}
                    columns={this.getColumns(t)}
                    defaultPageSize={6}
                    style={{
                      width: '100%'
                    }}
                    {...reactTableText}
                  />
                </CardBody>
              </Card>
            </Colxx>
          </Row>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = state => ({
  tokens: state.general.tokens,
});

export default connect(mapStateToProps)(withTranslation()(RangeUserFeeReport));
